import React, {Component} from "react"

import teamService from "@irati/identity/services/teams"
import {Input} from "@irati/ui/src/FormItem"
import Loading from "@irati/ui/src/Loading"
import {H3} from "@irati/ui/src//Typography/Heading"
import {Para} from "@irati/ui/src/Labels"
import Form from "@irati/ui/src/Form"
import CloseIcon from "@irati/ui/src/Close"
import {FormattedMessage} from "@irati/utils/lang"

import authentication from "@irati/auth"
import {Button} from "../styled"

interface Props {
  createTeam: (name: string) => Promise<void>,
  onSuccess: () => void,
  onCancel: () => void
}

interface State {
  creatingTeam?: Promise<void>,
  teamName: string
}

class CreateTeamForm extends Component<Props, State> {
  state: State = {
    teamName: ""
  }

  handleChange = (teamName: string) => {
    this.setState({teamName})
  }

  handleSubmit = () => {
    const creatingTeam = teamService
      .create({tenantId: authentication.business().uuid, data: {public_name: this.state.teamName.trim()}})
      .then(() => this.props.onSuccess())
    this.setState({creatingTeam})
  }

  render() {
    const {teamName, creatingTeam} = this.state
    return (
      <Loading load={creatingTeam}>
        <div style={{position: "relative"}}>
          <H3>
            <FormattedMessage id="setup_tenant.steps.teams.createTeamForm.title" />
          </H3>
          <Para margin="15px 0 30px">
            <FormattedMessage id="setup_tenant.steps.teams.createTeamForm.description" />
          </Para>
          <Form>
            <Input name="teamName" label="Team name" placeholder="e.g. Marketing" value={teamName} onChange={this.handleChange} />
            <Button primary onClick={this.handleSubmit} margin="15px 0">
              <FormattedMessage id="setup_tenant.steps.teams.createTeamForm.addTeamButton" />
            </Button>
          </Form>
          <CloseIcon onClick={this.props.onCancel} />
        </div>
      </Loading>
    )
  }
}

export default CreateTeamForm
